'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'business-time';
var width = 640;
var height = 512;
var aliases = ["briefcase-clock"];
var unicode = 'f64a';
var svgPathData = ['M112 160c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 50.7c-10.4-1.7-21.1-2.7-32-2.7-48.7 0-93.2 18.1-127 48l-257 0 0-96zm0 144l144 0 0 16c0 17.7 14.3 32 32 32l22 0c-3.9 15.3-6 31.4-6 48 0 10.9 .9 21.6 2.7 32L128 432c-8.8 0-16-7.2-16-16l0-112z', 'M256 56l0 40 128 0 0-40c0-4.4-3.6-8-8-8L264 48c-4.4 0-8 3.6-8 8zM208 96l0-40c0-30.9 25.1-56 56-56L376 0c30.9 0 56 25.1 56 56l0 40 80 0c35.3 0 64 28.7 64 64l0 65.4c-15.1-6.9-31.2-11.9-48-14.8l0-50.7c0-8.8-7.2-16-16-16l-384 0c-8.8 0-16 7.2-16 16l0 96 257 0c-28.3 25-49.2 58.3-59 96l-22 0c-17.7 0-32-14.3-32-32l0-16-144 0 0 112c0 8.8 7.2 16 16 16l178.7 0c2.8 16.8 7.8 32.9 14.8 48L128 480c-35.3 0-64-28.7-64-64l0-256c0-35.3 28.7-64 64-64l80 0zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBusinessTime = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;